module.exports = __webpack_public_path__ + "img/logo-04.8ef8cff0.png";